import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HostOrganizationProvider } from "./contexts/HostOrganizationProvider";
import { App } from "./App";

import "@/index.css";

// Public storefront entry. Mounts only the providers required by
// StorefrontPreview + the cart. No AccessProvider, no BrandingProvider,
// no FinancePanelProvider, no realtime listener — the storefront is anon
// and browse-only.
//
// `TooltipProvider` and `<Toaster />` are NOT mounted here: the v1
// browse-only storefront has no surfaces that emit toasts and no
// tooltip-dependent UI. Adding them just to mirror the BMS shell would
// pull `@radix-ui/react-tooltip` and the toast queue into the public
// bundle for zero functional benefit. Re-add them only when v2 (cart /
// checkout) actually needs them.

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Public storefront data is cacheable across mounts in the session.
      staleTime: 60 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found in index.storefront.html");

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <HostOrganizationProvider>
          <App />
        </HostOrganizationProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
